import React from "react";
import ReactDOM from "react-dom";


const MenuIcon = () =>{
    return(
        <>
         <svg xmlns="http://www.w3.org/2000/svg" width="23" height="15" viewBox="0 0 23 15" fill="none">
<path d="M2.0625 1.36914L20.9377 1.38212" stroke="#74A02F" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M2.125 7.38281L20.875 7.63281" stroke="#74A02F" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M1.9834 13.6328H21.0166" stroke="#74A02F" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
        </>
    )
}

export default MenuIcon;